import React from 'react';
import PropTypes from 'prop-types';

interface TableHeadProps {
  tableHeader: Object;
}

function TableHead({ tableHeader }: TableHeadProps) {
  return (
    <thead>
      <tr>
        {Object.entries(tableHeader).map(([key, { width, componentRenderer, label }]) => (
          <>
            <th key={key} style={{ width }}>
              {componentRenderer ? componentRenderer() : label}
            </th>
          </>
        ))}

      </tr>
    </thead>
  );
}

TableHead.propTypes = {
  tableHeader: PropTypes.object.isRequired,
};

export default TableHead;
